// extracted by mini-css-extract-plugin
export var cardLayout = "_8q-1";
export var paginationContainer = "_8q-0";